﻿<template>
  <div
    class="text-paragraph-2 text-center m-auto !h-full flex-1 flex flex-col justify-center select-none min-h-[80px]">
    <img
      :src="emptyLight"
      alt=""
      class="empty-item__img empty-item__img--light w-[180px] h-auto mx-auto" />
    <img
      :src="emptyDark"
      alt=""
      class="empty-item__img empty-item__img--dark w-[180px] h-auto mx-auto" />
    <p class="opacity-40 mt-24" :class="classP">{{ text }}</p>
  </div>
</template>

<script setup>
import emptyLight from './empty-state.svg'
import emptyDark from './empty-state-dark.svg'

defineProps({
  /**
   * Texto mostrado no item
   */
  text: {
    type: String,
    default: 'Nada para exibir no momento',
  },
  /**
   * Classes extras aplicadas ao texto
   */
  classP: String,
  /**
   * Mantidas por retrocompatibilidade com chamadas antigas â€” sem efeito.
   */
  icon: String,
  icons: Array,
})
</script>

<style lang="scss" scoped>
.empty-item__img {
  animation: empty-item-in 0.5s cubic-bezier(0.34, 1.36, 0.64, 1) both;
}

.empty-item__img--dark {
  display: none;
}

body.body--dark .empty-item__img--light,
body.dark .empty-item__img--light,
html.dark .empty-item__img--light {
  display: none;
}

body.body--dark .empty-item__img--dark,
body.dark .empty-item__img--dark,
html.dark .empty-item__img--dark {
  display: block;
}

@keyframes empty-item-in {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.8);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
</style>
